import axios from 'axios';
import cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';

/**
 * Удаляет запись о продаже товара
 * @param id UUID записи о продаже
 */
export async function deleteFishSale(id: string) {
	const token = cookies.get(TOKEN_COOKIE_NAME);

	await axios.delete(`${process.env.HOST}/api_v1/sell-fish/${id}/`, {
		headers: { Authorization: `Bearer ${token}` },
	});
}
